/**
 * Action type to set the spoken language preference.
 *
 * {
 *     type: SET_SPOKEN_LANGUAGE,
 *     language: string
 * }
 */
export const SET_SPOKEN_LANGUAGE = 'SET_SPOKEN_LANGUAGE';
